import React from "react";
import Button from "../../../components/Button/Button";
import { FaRedoAlt } from "react-icons/fa";

export default function QuizResults({
  questions = [],
  errors = [],
  score = 0,
  onRestart,
}) {
  const errorMap = new Map(errors.map((e) => [e.q.correctAnswer, e.selected]));

  return (
    <div>
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div>
          <h2 className="text-xl sm:text-2xl font-bold text-slate-900 dark:text-slate-100">
            Résultats
          </h2>
          <p className="text-sm sm:text-base text-slate-700 dark:text-slate-300 mt-1">
            Score : <span className="font-semibold">{score}</span> /{" "}
            {questions.length}
          </p>
        </div>

        <Button
          text="Recommencer"
          icon={FaRedoAlt}
          onClick={onRestart}
          className="!rounded-xl gap-2"
        />
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 mt-6">
        {questions.map((q, idx) => {
          const userAnswer = errorMap.get(q.correctAnswer);
          const isCorrect = !userAnswer;

          return (
            <div
              key={idx}
              className={`rounded-xl overflow-hidden border shadow-sm ${
                isCorrect
                  ? "bg-emerald-50/80 border-emerald-200 dark:bg-emerald-900/20 dark:border-emerald-800"
                  : "bg-rose-50/80 border-rose-200 dark:bg-rose-900/20 dark:border-rose-800"
              }`}
            >
              {/* Ratio strict 551/617, pas de déformation */}
              <div className="bg-white dark:bg-slate-900">
                <div className="w-full" style={{ aspectRatio: "551 / 617" }}>
                  <img
                    src={q.image}
                    alt={q.correctAnswer}
                    className="w-full h-full object-contain"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="p-3 text-center text-sm">
                {isCorrect ? (
                  <div className="font-semibold text-emerald-800 dark:text-emerald-200">
                    {q.correctAnswer}
                  </div>
                ) : (
                  <>
                    <div className="line-through text-rose-700 dark:text-rose-300">
                      {userAnswer}
                    </div>
                    <div className="font-semibold text-emerald-800 dark:text-emerald-200 mt-1">
                      {q.correctAnswer}
                    </div>
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
